import { ref, type Ref } from "vue";
import type { PayabliConfig } from "@/types";
import { usePayabliScript } from "./usePayabliScript";

export const usePayabliComponentLifecycle = () => {
  const isInitialized: Ref<boolean> = ref(false);
  const scriptLoaded = ref(false);
  let payabliComponent: PayabliComponent | null = null;

  const { loadScript, onLoaded } = usePayabliScript();

  const initialize = (config: PayabliConfig) => {
    onLoaded(() => {
      // Small delay to ensure the script is fully loaded
      setTimeout(() => {
        payabliComponent = new PayabliComponent(config);
        scriptLoaded.value = true;
      }, 300);
    });
  };

  const reinitialize = (config: PayabliConfig) => {
    if (scriptLoaded.value) {
      payabliComponent = new PayabliComponent(config);
    }
  };

  const getComponent = (): PayabliComponent | null => {
    return payabliComponent;
  };

  const setInitialized = (value: boolean) => {
    isInitialized.value = value;
  };

  return {
    isInitialized,
    loadScript,
    initialize,
    reinitialize,
    getComponent,
    setInitialized,
  };
};
